const features = [
  {
    title: 'Digital Membership Cards',
    description: 'QR-coded cards generated instantly on registration for every supporter.',
  },
  {
    title: 'Admin Analytics',
    description: 'Track membership growth, revenue, and chapter performance in real time.',
  },
  {
    title: 'Chapter Management',
    description: 'Organize supporters by region and branch with full coordinator control.',
  },
  {
    title: 'Subscription Tracking',
    description: 'Monitor paid vs unpaid members automatically with reminder emails.',
  },
  {
    title: 'Welfare Campaigns',
    description: 'Crowdfund support for members in need with transparent donation tracking.',
  },
  {
    title: 'Fixtures & Tables',
    description: 'Live match results, upcoming fixtures, and league standings all in one place.',
  },
]

export default function Features() {
  return (
    <section className="px-4 sm:px-8 py-12 sm:py-20">
      <h2 className="text-2xl sm:text-3xl font-black uppercase tracking-tight mb-6 sm:mb-10 text-gray-900 dark:text-white">
        Everything Your Club Needs
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
        {features.map((feature) => (
          <div
            key={feature.title}
            className="bg-gray-100 dark:bg-white/5 border border-gray-200 dark:border-white/10 hover:bg-green-50 dark:hover:bg-green-900/20 hover:border-green-300 dark:hover:border-green-800/50 p-5 sm:p-7 transition-all"
          >
            <h3 className="font-bold text-gray-900 dark:text-white text-base mb-3">{feature.title}</h3>
            <p className="text-gray-500 text-sm leading-relaxed">{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  )
}